import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getQueuedJobs(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("queued-jobs?" + parameters);
  return data;
}
